module.exports = __webpack_public_path__ + "static/media/evernote.58bf3276.png";